/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as PublicPwChangeRequiredRouteImport } from './routes/_public/pw-change-required'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicInvalidAuthRequestRouteImport } from './routes/_public/invalid-auth-request'
import { Route as PublicAuthErrorRouteImport } from './routes/_public/auth-error'
import { Route as AuthenticatedVerifyEmailRouteImport } from './routes/_authenticated/verify-email'
import { Route as AuthenticatedUserSettingsRouteImport } from './routes/_authenticated/user-settings'
import { Route as AuthenticatedTrialExpiredRouteImport } from './routes/_authenticated/trial-expired'
import { Route as AuthenticatedTransactionsRouteImport } from './routes/_authenticated/transactions'
import { Route as AuthenticatedTaxCheckoutRouteImport } from './routes/_authenticated/tax-checkout'
import { Route as AuthenticatedSubmissionsRouteImport } from './routes/_authenticated/submissions'
import { Route as AuthenticatedStakingRouteImport } from './routes/_authenticated/staking'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedPlanningRouteImport } from './routes/_authenticated/planning'
import { Route as AuthenticatedMonitoringRouteImport } from './routes/_authenticated/monitoring'
import { Route as AuthenticatedLogoutRouteImport } from './routes/_authenticated/logout'
import { Route as AuthenticatedFilesRouteImport } from './routes/_authenticated/files'
import { Route as AuthenticatedEmailVerifiedRouteImport } from './routes/_authenticated/email-verified'
import { Route as AuthenticatedDisabledRouteImport } from './routes/_authenticated/disabled'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedClientsRouteImport } from './routes/_authenticated/clients'
import { Route as AuthenticatedAuthCallbackRouteImport } from './routes/_authenticated/auth-callback'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as PublicSignupIndexRouteImport } from './routes/_public/signup/index'
import { Route as AuthenticatedStakingIndexRouteImport } from './routes/_authenticated/staking/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedIntegrationsIndexRouteImport } from './routes/_authenticated/integrations/index'
import { Route as AuthenticatedFilesIndexRouteImport } from './routes/_authenticated/files/index'
import { Route as AuthenticatedClientIndexRouteImport } from './routes/_authenticated/client/index'
import { Route as PublicSignupTokenRouteImport } from './routes/_public/signup/$token'
import { Route as PublicOauthCallbackProviderIdRouteImport } from './routes/_public/oauth-callback.$providerId'
import { Route as PublicAppIdSignupRouteImport } from './routes/_public/$appId.signup'
import { Route as PublicAppIdLoginRouteImport } from './routes/_public/$appId.login'
import { Route as AuthenticatedSubmissionsSubmissionIdRouteImport } from './routes/_authenticated/submissions/$submissionId'
import { Route as AuthenticatedStakingValidatorIdRouteImport } from './routes/_authenticated/staking/$validatorId'
import { Route as AuthenticatedSettingsTeamRouteImport } from './routes/_authenticated/settings/team'
import { Route as AuthenticatedSettingsLogsRouteImport } from './routes/_authenticated/settings/logs'
import { Route as AuthenticatedSettingsGeneralRouteImport } from './routes/_authenticated/settings/general'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedIntegrationsIntegrationIdRouteImport } from './routes/_authenticated/integrations/$integrationId'
import { Route as AuthenticatedFilesManagementRouteImport } from './routes/_authenticated/files/management'
import { Route as AuthenticatedFilesCorrectionsRouteImport } from './routes/_authenticated/files/corrections'
import { Route as AuthenticatedAppIdSplatRouteImport } from './routes/_authenticated/$appId/$'
import { Route as AuthenticatedsourcesWalletsIndexRouteImport } from './routes/_authenticated/(sources)/wallets/index'
import { Route as AuthenticatedsourcesSourcesIndexRouteImport } from './routes/_authenticated/(sources)/sources.index'
import { Route as AuthenticatedsourcesExchangesIndexRouteImport } from './routes/_authenticated/(sources)/exchanges/index'
import { Route as AuthenticatedClientAccountIdClientWrapperRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper'
import { Route as AuthenticatedsourcesSourcesAddRouteImport } from './routes/_authenticated/(sources)/sources.add'
import { Route as AuthenticatedClientAccountIdClientWrapperIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/index'
import { Route as AuthenticatedsourcesWalletsWalletIdIndexRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/index'
import { Route as AuthenticatedsourcesExchangesExchangeIdIndexRouteImport } from './routes/_authenticated/(sources)/exchanges/$exchangeId/index'
import { Route as AuthenticatedClientAccountIdClientWrapperTrialExpiredRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/trial-expired'
import { Route as AuthenticatedClientAccountIdClientWrapperTransactionsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/transactions'
import { Route as AuthenticatedClientAccountIdClientWrapperSubmissionsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/submissions'
import { Route as AuthenticatedClientAccountIdClientWrapperReportsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/reports'
import { Route as AuthenticatedClientAccountIdClientWrapperPlanningRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/planning'
import { Route as AuthenticatedClientAccountIdClientWrapperDisabledRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/disabled'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet'
import { Route as AuthenticatedsourcesExchangesExchangeIdExchangeRouteImport } from './routes/_authenticated/(sources)/exchanges/$exchangeId/_exchange'
import { Route as AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/settings/route'
import { Route as AuthenticatedClientAccountIdClientWrapperSettingsIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/settings/index'
import { Route as AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/integrations/index'
import { Route as AuthenticatedClientAccountIdClientWrapperSettingsTeamRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/settings/team'
import { Route as AuthenticatedClientAccountIdClientWrapperSettingsLogsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/settings/logs'
import { Route as AuthenticatedClientAccountIdClientWrapperSettingsGeneralRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/settings/general'
import { Route as AuthenticatedClientAccountIdClientWrapperSettingsBillingRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/settings/billing'
import { Route as AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/integrations/$integrationId'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletSummaryRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet/summary'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletSettingsRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet/settings'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletReconciliationRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet/reconciliation'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletImportsRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet/imports'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletDefiRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet/defi'
import { Route as AuthenticatedsourcesWalletsWalletIdWalletAddressesRouteImport } from './routes/_authenticated/(sources)/wallets/$walletId/_wallet/addresses'
import { Route as AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRouteImport } from './routes/_authenticated/(sources)/exchanges/$exchangeId/_exchange/summary'
import { Route as AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRouteImport } from './routes/_authenticated/(sources)/exchanges/$exchangeId/_exchange/settings'
import { Route as AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRouteImport } from './routes/_authenticated/(sources)/exchanges/$exchangeId/_exchange/reconciliation'
import { Route as AuthenticatedsourcesExchangesExchangeIdExchangeImportsRouteImport } from './routes/_authenticated/(sources)/exchanges/$exchangeId/_exchange/imports'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/index'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/sources.index'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/index'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/sources.add'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/index'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/index'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/summary'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/settings'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/reconciliation'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/imports'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/defi'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/addresses'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/summary'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/settings'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/reconciliation'
import { Route as AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRouteImport } from './routes/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/imports'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicPwChangeRequiredRoute = PublicPwChangeRequiredRouteImport.update({
  id: '/pw-change-required',
  path: '/pw-change-required',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicInvalidAuthRequestRoute =
  PublicInvalidAuthRequestRouteImport.update({
    id: '/invalid-auth-request',
    path: '/invalid-auth-request',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicAuthErrorRoute = PublicAuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedVerifyEmailRoute =
  AuthenticatedVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserSettingsRoute =
  AuthenticatedUserSettingsRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTrialExpiredRoute =
  AuthenticatedTrialExpiredRouteImport.update({
    id: '/trial-expired',
    path: '/trial-expired',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTransactionsRoute =
  AuthenticatedTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaxCheckoutRoute =
  AuthenticatedTaxCheckoutRouteImport.update({
    id: '/tax-checkout',
    path: '/tax-checkout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSubmissionsRoute =
  AuthenticatedSubmissionsRouteImport.update({
    id: '/submissions',
    path: '/submissions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStakingRoute = AuthenticatedStakingRouteImport.update({
  id: '/staking',
  path: '/staking',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlanningRoute = AuthenticatedPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMonitoringRoute = AuthenticatedMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLogoutRoute = AuthenticatedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFilesRoute = AuthenticatedFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEmailVerifiedRoute =
  AuthenticatedEmailVerifiedRouteImport.update({
    id: '/email-verified',
    path: '/email-verified',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDisabledRoute = AuthenticatedDisabledRouteImport.update({
  id: '/disabled',
  path: '/disabled',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientsRoute = AuthenticatedClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuthCallbackRoute =
  AuthenticatedAuthCallbackRouteImport.update({
    id: '/auth-callback',
    path: '/auth-callback',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicSignupIndexRoute = PublicSignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedStakingIndexRoute =
  AuthenticatedStakingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedStakingRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedIntegrationsIndexRoute =
  AuthenticatedIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesIndexRoute = AuthenticatedFilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedFilesRoute,
} as any)
const AuthenticatedClientIndexRoute =
  AuthenticatedClientIndexRouteImport.update({
    id: '/client/',
    path: '/client/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PublicSignupTokenRoute = PublicSignupTokenRouteImport.update({
  id: '/signup/$token',
  path: '/signup/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicOauthCallbackProviderIdRoute =
  PublicOauthCallbackProviderIdRouteImport.update({
    id: '/oauth-callback/$providerId',
    path: '/oauth-callback/$providerId',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicAppIdSignupRoute = PublicAppIdSignupRouteImport.update({
  id: '/$appId/signup',
  path: '/$appId/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAppIdLoginRoute = PublicAppIdLoginRouteImport.update({
  id: '/$appId/login',
  path: '/$appId/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedSubmissionsSubmissionIdRoute =
  AuthenticatedSubmissionsSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => AuthenticatedSubmissionsRoute,
  } as any)
const AuthenticatedStakingValidatorIdRoute =
  AuthenticatedStakingValidatorIdRouteImport.update({
    id: '/$validatorId',
    path: '/$validatorId',
    getParentRoute: () => AuthenticatedStakingRoute,
  } as any)
const AuthenticatedSettingsTeamRoute =
  AuthenticatedSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsLogsRoute =
  AuthenticatedSettingsLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsGeneralRoute =
  AuthenticatedSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedIntegrationsIntegrationIdRoute =
  AuthenticatedIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesManagementRoute =
  AuthenticatedFilesManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => AuthenticatedFilesRoute,
  } as any)
const AuthenticatedFilesCorrectionsRoute =
  AuthenticatedFilesCorrectionsRouteImport.update({
    id: '/corrections',
    path: '/corrections',
    getParentRoute: () => AuthenticatedFilesRoute,
  } as any)
const AuthenticatedAppIdSplatRoute = AuthenticatedAppIdSplatRouteImport.update({
  id: '/$appId/$',
  path: '/$appId/$',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedsourcesWalletsIndexRoute =
  AuthenticatedsourcesWalletsIndexRouteImport.update({
    id: '/(sources)/wallets/',
    path: '/wallets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedsourcesSourcesIndexRoute =
  AuthenticatedsourcesSourcesIndexRouteImport.update({
    id: '/(sources)/sources/',
    path: '/sources/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedsourcesExchangesIndexRoute =
  AuthenticatedsourcesExchangesIndexRouteImport.update({
    id: '/(sources)/exchanges/',
    path: '/exchanges/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperRoute =
  AuthenticatedClientAccountIdClientWrapperRouteImport.update({
    id: '/client/$accountId/_clientWrapper',
    path: '/client/$accountId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedsourcesSourcesAddRoute =
  AuthenticatedsourcesSourcesAddRouteImport.update({
    id: '/(sources)/sources/add',
    path: '/sources/add',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperIndexRoute =
  AuthenticatedClientAccountIdClientWrapperIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdIndexRoute =
  AuthenticatedsourcesWalletsWalletIdIndexRouteImport.update({
    id: '/(sources)/wallets/$walletId/',
    path: '/wallets/$walletId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedsourcesExchangesExchangeIdIndexRoute =
  AuthenticatedsourcesExchangesExchangeIdIndexRouteImport.update({
    id: '/(sources)/exchanges/$exchangeId/',
    path: '/exchanges/$exchangeId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute =
  AuthenticatedClientAccountIdClientWrapperTrialExpiredRouteImport.update({
    id: '/trial-expired',
    path: '/trial-expired',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperTransactionsRoute =
  AuthenticatedClientAccountIdClientWrapperTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSubmissionsRoute =
  AuthenticatedClientAccountIdClientWrapperSubmissionsRouteImport.update({
    id: '/submissions',
    path: '/submissions',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperReportsRoute =
  AuthenticatedClientAccountIdClientWrapperReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperPlanningRoute =
  AuthenticatedClientAccountIdClientWrapperPlanningRouteImport.update({
    id: '/planning',
    path: '/planning',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperDisabledRoute =
  AuthenticatedClientAccountIdClientWrapperDisabledRouteImport.update({
    id: '/disabled',
    path: '/disabled',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdWalletRoute =
  AuthenticatedsourcesWalletsWalletIdWalletRouteImport.update({
    id: '/(sources)/wallets/$walletId/_wallet',
    path: '/wallets/$walletId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedsourcesExchangesExchangeIdExchangeRoute =
  AuthenticatedsourcesExchangesExchangeIdExchangeRouteImport.update({
    id: '/(sources)/exchanges/$exchangeId/_exchange',
    path: '/exchanges/$exchangeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute =
  AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute =
  AuthenticatedClientAccountIdClientWrapperSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute =
  AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute =
  AuthenticatedClientAccountIdClientWrapperSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () =>
      AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute =
  AuthenticatedClientAccountIdClientWrapperSettingsLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () =>
      AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute =
  AuthenticatedClientAccountIdClientWrapperSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute =
  AuthenticatedClientAccountIdClientWrapperSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () =>
      AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute =
  AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRouteImport.update(
    {
      id: '/integrations/$integrationId',
      path: '/integrations/$integrationId',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute =
  AuthenticatedsourcesWalletsWalletIdWalletSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedsourcesWalletsWalletIdWalletRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute =
  AuthenticatedsourcesWalletsWalletIdWalletSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedsourcesWalletsWalletIdWalletRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute =
  AuthenticatedsourcesWalletsWalletIdWalletReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => AuthenticatedsourcesWalletsWalletIdWalletRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdWalletImportsRoute =
  AuthenticatedsourcesWalletsWalletIdWalletImportsRouteImport.update({
    id: '/imports',
    path: '/imports',
    getParentRoute: () => AuthenticatedsourcesWalletsWalletIdWalletRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdWalletDefiRoute =
  AuthenticatedsourcesWalletsWalletIdWalletDefiRouteImport.update({
    id: '/defi',
    path: '/defi',
    getParentRoute: () => AuthenticatedsourcesWalletsWalletIdWalletRoute,
  } as any)
const AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute =
  AuthenticatedsourcesWalletsWalletIdWalletAddressesRouteImport.update({
    id: '/addresses',
    path: '/addresses',
    getParentRoute: () => AuthenticatedsourcesWalletsWalletIdWalletRoute,
  } as any)
const AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute =
  AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedsourcesExchangesExchangeIdExchangeRoute,
  } as any)
const AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute =
  AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedsourcesExchangesExchangeIdExchangeRoute,
  } as any)
const AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute =
  AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRouteImport.update(
    {
      id: '/reconciliation',
      path: '/reconciliation',
      getParentRoute: () =>
        AuthenticatedsourcesExchangesExchangeIdExchangeRoute,
    } as any,
  )
const AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute =
  AuthenticatedsourcesExchangesExchangeIdExchangeImportsRouteImport.update({
    id: '/imports',
    path: '/imports',
    getParentRoute: () => AuthenticatedsourcesExchangesExchangeIdExchangeRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRouteImport.update(
    {
      id: '/(sources)/wallets/',
      path: '/wallets/',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute =
  AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRouteImport.update(
    {
      id: '/(sources)/sources/',
      path: '/sources/',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRouteImport.update(
    {
      id: '/(sources)/exchanges/',
      path: '/exchanges/',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute =
  AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRouteImport.update({
    id: '/(sources)/sources/add',
    path: '/sources/add',
    getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
  } as any)
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRouteImport.update(
    {
      id: '/(sources)/wallets/$walletId/',
      path: '/wallets/$walletId/',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRouteImport.update(
    {
      id: '/(sources)/exchanges/$exchangeId/',
      path: '/exchanges/$exchangeId/',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteImport.update(
    {
      id: '/(sources)/wallets/$walletId/_wallet',
      path: '/wallets/$walletId',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteImport.update(
    {
      id: '/(sources)/exchanges/$exchangeId/_exchange',
      path: '/exchanges/$exchangeId',
      getParentRoute: () => AuthenticatedClientAccountIdClientWrapperRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRouteImport.update(
    {
      id: '/summary',
      path: '/summary',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRouteImport.update(
    {
      id: '/reconciliation',
      path: '/reconciliation',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRouteImport.update(
    {
      id: '/imports',
      path: '/imports',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRouteImport.update(
    {
      id: '/defi',
      path: '/defi',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRouteImport.update(
    {
      id: '/addresses',
      path: '/addresses',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRouteImport.update(
    {
      id: '/summary',
      path: '/summary',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRouteImport.update(
    {
      id: '/reconciliation',
      path: '/reconciliation',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute,
    } as any,
  )
const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRouteImport.update(
    {
      id: '/imports',
      path: '/imports',
      getParentRoute: () =>
        AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/auth-callback': typeof AuthenticatedAuthCallbackRoute
  '/clients': typeof AuthenticatedClientsRoute
  '/contacts': typeof AuthenticatedContactsRoute
  '/disabled': typeof AuthenticatedDisabledRoute
  '/email-verified': typeof AuthenticatedEmailVerifiedRoute
  '/files': typeof AuthenticatedFilesRouteWithChildren
  '/logout': typeof AuthenticatedLogoutRoute
  '/monitoring': typeof AuthenticatedMonitoringRoute
  '/planning': typeof AuthenticatedPlanningRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/staking': typeof AuthenticatedStakingRouteWithChildren
  '/submissions': typeof AuthenticatedSubmissionsRouteWithChildren
  '/tax-checkout': typeof AuthenticatedTaxCheckoutRoute
  '/transactions': typeof AuthenticatedTransactionsRoute
  '/trial-expired': typeof AuthenticatedTrialExpiredRoute
  '/user-settings': typeof AuthenticatedUserSettingsRoute
  '/verify-email': typeof AuthenticatedVerifyEmailRoute
  '/auth-error': typeof PublicAuthErrorRoute
  '/invalid-auth-request': typeof PublicInvalidAuthRequestRoute
  '/login': typeof PublicLoginRoute
  '/pw-change-required': typeof PublicPwChangeRequiredRoute
  '/$appId/$': typeof AuthenticatedAppIdSplatRoute
  '/files/corrections': typeof AuthenticatedFilesCorrectionsRoute
  '/files/management': typeof AuthenticatedFilesManagementRoute
  '/integrations/$integrationId': typeof AuthenticatedIntegrationsIntegrationIdRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/settings/logs': typeof AuthenticatedSettingsLogsRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/staking/$validatorId': typeof AuthenticatedStakingValidatorIdRoute
  '/submissions/$submissionId': typeof AuthenticatedSubmissionsSubmissionIdRoute
  '/$appId/login': typeof PublicAppIdLoginRoute
  '/$appId/signup': typeof PublicAppIdSignupRoute
  '/oauth-callback/$providerId': typeof PublicOauthCallbackProviderIdRoute
  '/signup/$token': typeof PublicSignupTokenRoute
  '/client/': typeof AuthenticatedClientIndexRoute
  '/files/': typeof AuthenticatedFilesIndexRoute
  '/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/staking/': typeof AuthenticatedStakingIndexRoute
  '/signup/': typeof PublicSignupIndexRoute
  '/sources/add': typeof AuthenticatedsourcesSourcesAddRoute
  '/client/$accountId': typeof AuthenticatedClientAccountIdClientWrapperRouteWithChildren
  '/exchanges/': typeof AuthenticatedsourcesExchangesIndexRoute
  '/sources/': typeof AuthenticatedsourcesSourcesIndexRoute
  '/wallets/': typeof AuthenticatedsourcesWalletsIndexRoute
  '/client/$accountId/settings': typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteWithChildren
  '/exchanges/$exchangeId': typeof AuthenticatedsourcesExchangesExchangeIdExchangeRouteWithChildren
  '/wallets/$walletId': typeof AuthenticatedsourcesWalletsWalletIdWalletRouteWithChildren
  '/client/$accountId/disabled': typeof AuthenticatedClientAccountIdClientWrapperDisabledRoute
  '/client/$accountId/planning': typeof AuthenticatedClientAccountIdClientWrapperPlanningRoute
  '/client/$accountId/reports': typeof AuthenticatedClientAccountIdClientWrapperReportsRoute
  '/client/$accountId/submissions': typeof AuthenticatedClientAccountIdClientWrapperSubmissionsRoute
  '/client/$accountId/transactions': typeof AuthenticatedClientAccountIdClientWrapperTransactionsRoute
  '/client/$accountId/trial-expired': typeof AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute
  '/exchanges/$exchangeId/': typeof AuthenticatedsourcesExchangesExchangeIdIndexRoute
  '/wallets/$walletId/': typeof AuthenticatedsourcesWalletsWalletIdIndexRoute
  '/client/$accountId/': typeof AuthenticatedClientAccountIdClientWrapperIndexRoute
  '/exchanges/$exchangeId/imports': typeof AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute
  '/exchanges/$exchangeId/reconciliation': typeof AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute
  '/exchanges/$exchangeId/settings': typeof AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute
  '/exchanges/$exchangeId/summary': typeof AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute
  '/wallets/$walletId/addresses': typeof AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute
  '/wallets/$walletId/defi': typeof AuthenticatedsourcesWalletsWalletIdWalletDefiRoute
  '/wallets/$walletId/imports': typeof AuthenticatedsourcesWalletsWalletIdWalletImportsRoute
  '/wallets/$walletId/reconciliation': typeof AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute
  '/wallets/$walletId/settings': typeof AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute
  '/wallets/$walletId/summary': typeof AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute
  '/client/$accountId/integrations/$integrationId': typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute
  '/client/$accountId/settings/billing': typeof AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute
  '/client/$accountId/settings/general': typeof AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute
  '/client/$accountId/settings/logs': typeof AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute
  '/client/$accountId/settings/team': typeof AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute
  '/client/$accountId/integrations/': typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute
  '/client/$accountId/settings/': typeof AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute
  '/client/$accountId/sources/add': typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute
  '/client/$accountId/exchanges/': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute
  '/client/$accountId/sources/': typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute
  '/client/$accountId/wallets/': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute
  '/client/$accountId/exchanges/$exchangeId': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteWithChildren
  '/client/$accountId/wallets/$walletId': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteWithChildren
  '/client/$accountId/exchanges/$exchangeId/': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute
  '/client/$accountId/wallets/$walletId/': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute
  '/client/$accountId/exchanges/$exchangeId/imports': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute
  '/client/$accountId/exchanges/$exchangeId/reconciliation': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute
  '/client/$accountId/exchanges/$exchangeId/settings': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute
  '/client/$accountId/exchanges/$exchangeId/summary': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute
  '/client/$accountId/wallets/$walletId/addresses': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute
  '/client/$accountId/wallets/$walletId/defi': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute
  '/client/$accountId/wallets/$walletId/imports': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute
  '/client/$accountId/wallets/$walletId/reconciliation': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute
  '/client/$accountId/wallets/$walletId/settings': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute
  '/client/$accountId/wallets/$walletId/summary': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/auth-callback': typeof AuthenticatedAuthCallbackRoute
  '/clients': typeof AuthenticatedClientsRoute
  '/contacts': typeof AuthenticatedContactsRoute
  '/disabled': typeof AuthenticatedDisabledRoute
  '/email-verified': typeof AuthenticatedEmailVerifiedRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/monitoring': typeof AuthenticatedMonitoringRoute
  '/planning': typeof AuthenticatedPlanningRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/submissions': typeof AuthenticatedSubmissionsRouteWithChildren
  '/tax-checkout': typeof AuthenticatedTaxCheckoutRoute
  '/transactions': typeof AuthenticatedTransactionsRoute
  '/trial-expired': typeof AuthenticatedTrialExpiredRoute
  '/user-settings': typeof AuthenticatedUserSettingsRoute
  '/verify-email': typeof AuthenticatedVerifyEmailRoute
  '/auth-error': typeof PublicAuthErrorRoute
  '/invalid-auth-request': typeof PublicInvalidAuthRequestRoute
  '/login': typeof PublicLoginRoute
  '/pw-change-required': typeof PublicPwChangeRequiredRoute
  '/$appId/$': typeof AuthenticatedAppIdSplatRoute
  '/files/corrections': typeof AuthenticatedFilesCorrectionsRoute
  '/files/management': typeof AuthenticatedFilesManagementRoute
  '/integrations/$integrationId': typeof AuthenticatedIntegrationsIntegrationIdRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/settings/logs': typeof AuthenticatedSettingsLogsRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/staking/$validatorId': typeof AuthenticatedStakingValidatorIdRoute
  '/submissions/$submissionId': typeof AuthenticatedSubmissionsSubmissionIdRoute
  '/$appId/login': typeof PublicAppIdLoginRoute
  '/$appId/signup': typeof PublicAppIdSignupRoute
  '/oauth-callback/$providerId': typeof PublicOauthCallbackProviderIdRoute
  '/signup/$token': typeof PublicSignupTokenRoute
  '/client': typeof AuthenticatedClientIndexRoute
  '/files': typeof AuthenticatedFilesIndexRoute
  '/integrations': typeof AuthenticatedIntegrationsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/staking': typeof AuthenticatedStakingIndexRoute
  '/signup': typeof PublicSignupIndexRoute
  '/sources/add': typeof AuthenticatedsourcesSourcesAddRoute
  '/exchanges': typeof AuthenticatedsourcesExchangesIndexRoute
  '/sources': typeof AuthenticatedsourcesSourcesIndexRoute
  '/wallets': typeof AuthenticatedsourcesWalletsIndexRoute
  '/exchanges/$exchangeId': typeof AuthenticatedsourcesExchangesExchangeIdIndexRoute
  '/wallets/$walletId': typeof AuthenticatedsourcesWalletsWalletIdIndexRoute
  '/client/$accountId/disabled': typeof AuthenticatedClientAccountIdClientWrapperDisabledRoute
  '/client/$accountId/planning': typeof AuthenticatedClientAccountIdClientWrapperPlanningRoute
  '/client/$accountId/reports': typeof AuthenticatedClientAccountIdClientWrapperReportsRoute
  '/client/$accountId/submissions': typeof AuthenticatedClientAccountIdClientWrapperSubmissionsRoute
  '/client/$accountId/transactions': typeof AuthenticatedClientAccountIdClientWrapperTransactionsRoute
  '/client/$accountId/trial-expired': typeof AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute
  '/client/$accountId': typeof AuthenticatedClientAccountIdClientWrapperIndexRoute
  '/exchanges/$exchangeId/imports': typeof AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute
  '/exchanges/$exchangeId/reconciliation': typeof AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute
  '/exchanges/$exchangeId/settings': typeof AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute
  '/exchanges/$exchangeId/summary': typeof AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute
  '/wallets/$walletId/addresses': typeof AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute
  '/wallets/$walletId/defi': typeof AuthenticatedsourcesWalletsWalletIdWalletDefiRoute
  '/wallets/$walletId/imports': typeof AuthenticatedsourcesWalletsWalletIdWalletImportsRoute
  '/wallets/$walletId/reconciliation': typeof AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute
  '/wallets/$walletId/settings': typeof AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute
  '/wallets/$walletId/summary': typeof AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute
  '/client/$accountId/integrations/$integrationId': typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute
  '/client/$accountId/settings/billing': typeof AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute
  '/client/$accountId/settings/general': typeof AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute
  '/client/$accountId/settings/logs': typeof AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute
  '/client/$accountId/settings/team': typeof AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute
  '/client/$accountId/integrations': typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute
  '/client/$accountId/settings': typeof AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute
  '/client/$accountId/sources/add': typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute
  '/client/$accountId/exchanges': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute
  '/client/$accountId/sources': typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute
  '/client/$accountId/wallets': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute
  '/client/$accountId/exchanges/$exchangeId': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute
  '/client/$accountId/wallets/$walletId': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute
  '/client/$accountId/exchanges/$exchangeId/imports': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute
  '/client/$accountId/exchanges/$exchangeId/reconciliation': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute
  '/client/$accountId/exchanges/$exchangeId/settings': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute
  '/client/$accountId/exchanges/$exchangeId/summary': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute
  '/client/$accountId/wallets/$walletId/addresses': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute
  '/client/$accountId/wallets/$walletId/defi': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute
  '/client/$accountId/wallets/$walletId/imports': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute
  '/client/$accountId/wallets/$walletId/reconciliation': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute
  '/client/$accountId/wallets/$walletId/settings': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute
  '/client/$accountId/wallets/$walletId/summary': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/auth-callback': typeof AuthenticatedAuthCallbackRoute
  '/_authenticated/clients': typeof AuthenticatedClientsRoute
  '/_authenticated/contacts': typeof AuthenticatedContactsRoute
  '/_authenticated/disabled': typeof AuthenticatedDisabledRoute
  '/_authenticated/email-verified': typeof AuthenticatedEmailVerifiedRoute
  '/_authenticated/files': typeof AuthenticatedFilesRouteWithChildren
  '/_authenticated/logout': typeof AuthenticatedLogoutRoute
  '/_authenticated/monitoring': typeof AuthenticatedMonitoringRoute
  '/_authenticated/planning': typeof AuthenticatedPlanningRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/staking': typeof AuthenticatedStakingRouteWithChildren
  '/_authenticated/submissions': typeof AuthenticatedSubmissionsRouteWithChildren
  '/_authenticated/tax-checkout': typeof AuthenticatedTaxCheckoutRoute
  '/_authenticated/transactions': typeof AuthenticatedTransactionsRoute
  '/_authenticated/trial-expired': typeof AuthenticatedTrialExpiredRoute
  '/_authenticated/user-settings': typeof AuthenticatedUserSettingsRoute
  '/_authenticated/verify-email': typeof AuthenticatedVerifyEmailRoute
  '/_public/auth-error': typeof PublicAuthErrorRoute
  '/_public/invalid-auth-request': typeof PublicInvalidAuthRequestRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/pw-change-required': typeof PublicPwChangeRequiredRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$appId/$': typeof AuthenticatedAppIdSplatRoute
  '/_authenticated/files/corrections': typeof AuthenticatedFilesCorrectionsRoute
  '/_authenticated/files/management': typeof AuthenticatedFilesManagementRoute
  '/_authenticated/integrations/$integrationId': typeof AuthenticatedIntegrationsIntegrationIdRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/general': typeof AuthenticatedSettingsGeneralRoute
  '/_authenticated/settings/logs': typeof AuthenticatedSettingsLogsRoute
  '/_authenticated/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/_authenticated/staking/$validatorId': typeof AuthenticatedStakingValidatorIdRoute
  '/_authenticated/submissions/$submissionId': typeof AuthenticatedSubmissionsSubmissionIdRoute
  '/_public/$appId/login': typeof PublicAppIdLoginRoute
  '/_public/$appId/signup': typeof PublicAppIdSignupRoute
  '/_public/oauth-callback/$providerId': typeof PublicOauthCallbackProviderIdRoute
  '/_public/signup/$token': typeof PublicSignupTokenRoute
  '/_authenticated/client/': typeof AuthenticatedClientIndexRoute
  '/_authenticated/files/': typeof AuthenticatedFilesIndexRoute
  '/_authenticated/integrations/': typeof AuthenticatedIntegrationsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/staking/': typeof AuthenticatedStakingIndexRoute
  '/_public/signup/': typeof PublicSignupIndexRoute
  '/_authenticated/(sources)/sources/add': typeof AuthenticatedsourcesSourcesAddRoute
  '/_authenticated/client/$accountId/_clientWrapper': typeof AuthenticatedClientAccountIdClientWrapperRouteWithChildren
  '/_authenticated/(sources)/exchanges/': typeof AuthenticatedsourcesExchangesIndexRoute
  '/_authenticated/(sources)/sources/': typeof AuthenticatedsourcesSourcesIndexRoute
  '/_authenticated/(sources)/wallets/': typeof AuthenticatedsourcesWalletsIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/settings': typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteWithChildren
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange': typeof AuthenticatedsourcesExchangesExchangeIdExchangeRouteWithChildren
  '/_authenticated/(sources)/wallets/$walletId/_wallet': typeof AuthenticatedsourcesWalletsWalletIdWalletRouteWithChildren
  '/_authenticated/client/$accountId/_clientWrapper/disabled': typeof AuthenticatedClientAccountIdClientWrapperDisabledRoute
  '/_authenticated/client/$accountId/_clientWrapper/planning': typeof AuthenticatedClientAccountIdClientWrapperPlanningRoute
  '/_authenticated/client/$accountId/_clientWrapper/reports': typeof AuthenticatedClientAccountIdClientWrapperReportsRoute
  '/_authenticated/client/$accountId/_clientWrapper/submissions': typeof AuthenticatedClientAccountIdClientWrapperSubmissionsRoute
  '/_authenticated/client/$accountId/_clientWrapper/transactions': typeof AuthenticatedClientAccountIdClientWrapperTransactionsRoute
  '/_authenticated/client/$accountId/_clientWrapper/trial-expired': typeof AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute
  '/_authenticated/(sources)/exchanges/$exchangeId/': typeof AuthenticatedsourcesExchangesExchangeIdIndexRoute
  '/_authenticated/(sources)/wallets/$walletId/': typeof AuthenticatedsourcesWalletsWalletIdIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/': typeof AuthenticatedClientAccountIdClientWrapperIndexRoute
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/imports': typeof AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/reconciliation': typeof AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/settings': typeof AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/summary': typeof AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute
  '/_authenticated/(sources)/wallets/$walletId/_wallet/addresses': typeof AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute
  '/_authenticated/(sources)/wallets/$walletId/_wallet/defi': typeof AuthenticatedsourcesWalletsWalletIdWalletDefiRoute
  '/_authenticated/(sources)/wallets/$walletId/_wallet/imports': typeof AuthenticatedsourcesWalletsWalletIdWalletImportsRoute
  '/_authenticated/(sources)/wallets/$walletId/_wallet/reconciliation': typeof AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute
  '/_authenticated/(sources)/wallets/$walletId/_wallet/settings': typeof AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute
  '/_authenticated/(sources)/wallets/$walletId/_wallet/summary': typeof AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute
  '/_authenticated/client/$accountId/_clientWrapper/integrations/$integrationId': typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute
  '/_authenticated/client/$accountId/_clientWrapper/settings/billing': typeof AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute
  '/_authenticated/client/$accountId/_clientWrapper/settings/general': typeof AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute
  '/_authenticated/client/$accountId/_clientWrapper/settings/logs': typeof AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute
  '/_authenticated/client/$accountId/_clientWrapper/settings/team': typeof AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute
  '/_authenticated/client/$accountId/_clientWrapper/integrations/': typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/settings/': typeof AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/add': typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/': typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteWithChildren
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteWithChildren
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/imports': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/reconciliation': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/settings': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/summary': typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/addresses': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/defi': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/imports': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/reconciliation': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/settings': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/summary': typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/auth-callback'
    | '/clients'
    | '/contacts'
    | '/disabled'
    | '/email-verified'
    | '/files'
    | '/logout'
    | '/monitoring'
    | '/planning'
    | '/reports'
    | '/staking'
    | '/submissions'
    | '/tax-checkout'
    | '/transactions'
    | '/trial-expired'
    | '/user-settings'
    | '/verify-email'
    | '/auth-error'
    | '/invalid-auth-request'
    | '/login'
    | '/pw-change-required'
    | '/$appId/$'
    | '/files/corrections'
    | '/files/management'
    | '/integrations/$integrationId'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/logs'
    | '/settings/team'
    | '/staking/$validatorId'
    | '/submissions/$submissionId'
    | '/$appId/login'
    | '/$appId/signup'
    | '/oauth-callback/$providerId'
    | '/signup/$token'
    | '/client/'
    | '/files/'
    | '/integrations/'
    | '/settings/'
    | '/staking/'
    | '/signup/'
    | '/sources/add'
    | '/client/$accountId'
    | '/exchanges/'
    | '/sources/'
    | '/wallets/'
    | '/client/$accountId/settings'
    | '/exchanges/$exchangeId'
    | '/wallets/$walletId'
    | '/client/$accountId/disabled'
    | '/client/$accountId/planning'
    | '/client/$accountId/reports'
    | '/client/$accountId/submissions'
    | '/client/$accountId/transactions'
    | '/client/$accountId/trial-expired'
    | '/exchanges/$exchangeId/'
    | '/wallets/$walletId/'
    | '/client/$accountId/'
    | '/exchanges/$exchangeId/imports'
    | '/exchanges/$exchangeId/reconciliation'
    | '/exchanges/$exchangeId/settings'
    | '/exchanges/$exchangeId/summary'
    | '/wallets/$walletId/addresses'
    | '/wallets/$walletId/defi'
    | '/wallets/$walletId/imports'
    | '/wallets/$walletId/reconciliation'
    | '/wallets/$walletId/settings'
    | '/wallets/$walletId/summary'
    | '/client/$accountId/integrations/$integrationId'
    | '/client/$accountId/settings/billing'
    | '/client/$accountId/settings/general'
    | '/client/$accountId/settings/logs'
    | '/client/$accountId/settings/team'
    | '/client/$accountId/integrations/'
    | '/client/$accountId/settings/'
    | '/client/$accountId/sources/add'
    | '/client/$accountId/exchanges/'
    | '/client/$accountId/sources/'
    | '/client/$accountId/wallets/'
    | '/client/$accountId/exchanges/$exchangeId'
    | '/client/$accountId/wallets/$walletId'
    | '/client/$accountId/exchanges/$exchangeId/'
    | '/client/$accountId/wallets/$walletId/'
    | '/client/$accountId/exchanges/$exchangeId/imports'
    | '/client/$accountId/exchanges/$exchangeId/reconciliation'
    | '/client/$accountId/exchanges/$exchangeId/settings'
    | '/client/$accountId/exchanges/$exchangeId/summary'
    | '/client/$accountId/wallets/$walletId/addresses'
    | '/client/$accountId/wallets/$walletId/defi'
    | '/client/$accountId/wallets/$walletId/imports'
    | '/client/$accountId/wallets/$walletId/reconciliation'
    | '/client/$accountId/wallets/$walletId/settings'
    | '/client/$accountId/wallets/$walletId/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-callback'
    | '/clients'
    | '/contacts'
    | '/disabled'
    | '/email-verified'
    | '/logout'
    | '/monitoring'
    | '/planning'
    | '/reports'
    | '/submissions'
    | '/tax-checkout'
    | '/transactions'
    | '/trial-expired'
    | '/user-settings'
    | '/verify-email'
    | '/auth-error'
    | '/invalid-auth-request'
    | '/login'
    | '/pw-change-required'
    | '/$appId/$'
    | '/files/corrections'
    | '/files/management'
    | '/integrations/$integrationId'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/logs'
    | '/settings/team'
    | '/staking/$validatorId'
    | '/submissions/$submissionId'
    | '/$appId/login'
    | '/$appId/signup'
    | '/oauth-callback/$providerId'
    | '/signup/$token'
    | '/client'
    | '/files'
    | '/integrations'
    | '/settings'
    | '/staking'
    | '/signup'
    | '/sources/add'
    | '/exchanges'
    | '/sources'
    | '/wallets'
    | '/exchanges/$exchangeId'
    | '/wallets/$walletId'
    | '/client/$accountId/disabled'
    | '/client/$accountId/planning'
    | '/client/$accountId/reports'
    | '/client/$accountId/submissions'
    | '/client/$accountId/transactions'
    | '/client/$accountId/trial-expired'
    | '/client/$accountId'
    | '/exchanges/$exchangeId/imports'
    | '/exchanges/$exchangeId/reconciliation'
    | '/exchanges/$exchangeId/settings'
    | '/exchanges/$exchangeId/summary'
    | '/wallets/$walletId/addresses'
    | '/wallets/$walletId/defi'
    | '/wallets/$walletId/imports'
    | '/wallets/$walletId/reconciliation'
    | '/wallets/$walletId/settings'
    | '/wallets/$walletId/summary'
    | '/client/$accountId/integrations/$integrationId'
    | '/client/$accountId/settings/billing'
    | '/client/$accountId/settings/general'
    | '/client/$accountId/settings/logs'
    | '/client/$accountId/settings/team'
    | '/client/$accountId/integrations'
    | '/client/$accountId/settings'
    | '/client/$accountId/sources/add'
    | '/client/$accountId/exchanges'
    | '/client/$accountId/sources'
    | '/client/$accountId/wallets'
    | '/client/$accountId/exchanges/$exchangeId'
    | '/client/$accountId/wallets/$walletId'
    | '/client/$accountId/exchanges/$exchangeId/imports'
    | '/client/$accountId/exchanges/$exchangeId/reconciliation'
    | '/client/$accountId/exchanges/$exchangeId/settings'
    | '/client/$accountId/exchanges/$exchangeId/summary'
    | '/client/$accountId/wallets/$walletId/addresses'
    | '/client/$accountId/wallets/$walletId/defi'
    | '/client/$accountId/wallets/$walletId/imports'
    | '/client/$accountId/wallets/$walletId/reconciliation'
    | '/client/$accountId/wallets/$walletId/settings'
    | '/client/$accountId/wallets/$walletId/summary'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/settings'
    | '/_authenticated/auth-callback'
    | '/_authenticated/clients'
    | '/_authenticated/contacts'
    | '/_authenticated/disabled'
    | '/_authenticated/email-verified'
    | '/_authenticated/files'
    | '/_authenticated/logout'
    | '/_authenticated/monitoring'
    | '/_authenticated/planning'
    | '/_authenticated/reports'
    | '/_authenticated/staking'
    | '/_authenticated/submissions'
    | '/_authenticated/tax-checkout'
    | '/_authenticated/transactions'
    | '/_authenticated/trial-expired'
    | '/_authenticated/user-settings'
    | '/_authenticated/verify-email'
    | '/_public/auth-error'
    | '/_public/invalid-auth-request'
    | '/_public/login'
    | '/_public/pw-change-required'
    | '/_authenticated/'
    | '/_authenticated/$appId/$'
    | '/_authenticated/files/corrections'
    | '/_authenticated/files/management'
    | '/_authenticated/integrations/$integrationId'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/general'
    | '/_authenticated/settings/logs'
    | '/_authenticated/settings/team'
    | '/_authenticated/staking/$validatorId'
    | '/_authenticated/submissions/$submissionId'
    | '/_public/$appId/login'
    | '/_public/$appId/signup'
    | '/_public/oauth-callback/$providerId'
    | '/_public/signup/$token'
    | '/_authenticated/client/'
    | '/_authenticated/files/'
    | '/_authenticated/integrations/'
    | '/_authenticated/settings/'
    | '/_authenticated/staking/'
    | '/_public/signup/'
    | '/_authenticated/(sources)/sources/add'
    | '/_authenticated/client/$accountId/_clientWrapper'
    | '/_authenticated/(sources)/exchanges/'
    | '/_authenticated/(sources)/sources/'
    | '/_authenticated/(sources)/wallets/'
    | '/_authenticated/client/$accountId/_clientWrapper/settings'
    | '/_authenticated/(sources)/exchanges/$exchangeId/_exchange'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet'
    | '/_authenticated/client/$accountId/_clientWrapper/disabled'
    | '/_authenticated/client/$accountId/_clientWrapper/planning'
    | '/_authenticated/client/$accountId/_clientWrapper/reports'
    | '/_authenticated/client/$accountId/_clientWrapper/submissions'
    | '/_authenticated/client/$accountId/_clientWrapper/transactions'
    | '/_authenticated/client/$accountId/_clientWrapper/trial-expired'
    | '/_authenticated/(sources)/exchanges/$exchangeId/'
    | '/_authenticated/(sources)/wallets/$walletId/'
    | '/_authenticated/client/$accountId/_clientWrapper/'
    | '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/imports'
    | '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/reconciliation'
    | '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/settings'
    | '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/summary'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet/addresses'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet/defi'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet/imports'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet/reconciliation'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet/settings'
    | '/_authenticated/(sources)/wallets/$walletId/_wallet/summary'
    | '/_authenticated/client/$accountId/_clientWrapper/integrations/$integrationId'
    | '/_authenticated/client/$accountId/_clientWrapper/settings/billing'
    | '/_authenticated/client/$accountId/_clientWrapper/settings/general'
    | '/_authenticated/client/$accountId/_clientWrapper/settings/logs'
    | '/_authenticated/client/$accountId/_clientWrapper/settings/team'
    | '/_authenticated/client/$accountId/_clientWrapper/integrations/'
    | '/_authenticated/client/$accountId/_clientWrapper/settings/'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/add'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/imports'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/reconciliation'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/settings'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/summary'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/addresses'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/defi'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/imports'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/reconciliation'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/settings'
    | '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/pw-change-required': {
      id: '/_public/pw-change-required'
      path: '/pw-change-required'
      fullPath: '/pw-change-required'
      preLoaderRoute: typeof PublicPwChangeRequiredRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/invalid-auth-request': {
      id: '/_public/invalid-auth-request'
      path: '/invalid-auth-request'
      fullPath: '/invalid-auth-request'
      preLoaderRoute: typeof PublicInvalidAuthRequestRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth-error': {
      id: '/_public/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof PublicAuthErrorRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/verify-email': {
      id: '/_authenticated/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthenticatedVerifyEmailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user-settings': {
      id: '/_authenticated/user-settings'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof AuthenticatedUserSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trial-expired': {
      id: '/_authenticated/trial-expired'
      path: '/trial-expired'
      fullPath: '/trial-expired'
      preLoaderRoute: typeof AuthenticatedTrialExpiredRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transactions': {
      id: '/_authenticated/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthenticatedTransactionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tax-checkout': {
      id: '/_authenticated/tax-checkout'
      path: '/tax-checkout'
      fullPath: '/tax-checkout'
      preLoaderRoute: typeof AuthenticatedTaxCheckoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/submissions': {
      id: '/_authenticated/submissions'
      path: '/submissions'
      fullPath: '/submissions'
      preLoaderRoute: typeof AuthenticatedSubmissionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/staking': {
      id: '/_authenticated/staking'
      path: '/staking'
      fullPath: '/staking'
      preLoaderRoute: typeof AuthenticatedStakingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/planning': {
      id: '/_authenticated/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof AuthenticatedPlanningRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/monitoring': {
      id: '/_authenticated/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof AuthenticatedMonitoringRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logout': {
      id: '/_authenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLogoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files': {
      id: '/_authenticated/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthenticatedFilesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-verified': {
      id: '/_authenticated/email-verified'
      path: '/email-verified'
      fullPath: '/email-verified'
      preLoaderRoute: typeof AuthenticatedEmailVerifiedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/disabled': {
      id: '/_authenticated/disabled'
      path: '/disabled'
      fullPath: '/disabled'
      preLoaderRoute: typeof AuthenticatedDisabledRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients': {
      id: '/_authenticated/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedClientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/auth-callback': {
      id: '/_authenticated/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthenticatedAuthCallbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/signup/': {
      id: '/_public/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof PublicSignupIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/staking/': {
      id: '/_authenticated/staking/'
      path: '/'
      fullPath: '/staking/'
      preLoaderRoute: typeof AuthenticatedStakingIndexRouteImport
      parentRoute: typeof AuthenticatedStakingRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/integrations/': {
      id: '/_authenticated/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof AuthenticatedIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/': {
      id: '/_authenticated/files/'
      path: '/'
      fullPath: '/files/'
      preLoaderRoute: typeof AuthenticatedFilesIndexRouteImport
      parentRoute: typeof AuthenticatedFilesRoute
    }
    '/_authenticated/client/': {
      id: '/_authenticated/client/'
      path: '/client'
      fullPath: '/client/'
      preLoaderRoute: typeof AuthenticatedClientIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/signup/$token': {
      id: '/_public/signup/$token'
      path: '/signup/$token'
      fullPath: '/signup/$token'
      preLoaderRoute: typeof PublicSignupTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/oauth-callback/$providerId': {
      id: '/_public/oauth-callback/$providerId'
      path: '/oauth-callback/$providerId'
      fullPath: '/oauth-callback/$providerId'
      preLoaderRoute: typeof PublicOauthCallbackProviderIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/$appId/signup': {
      id: '/_public/$appId/signup'
      path: '/$appId/signup'
      fullPath: '/$appId/signup'
      preLoaderRoute: typeof PublicAppIdSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/$appId/login': {
      id: '/_public/$appId/login'
      path: '/$appId/login'
      fullPath: '/$appId/login'
      preLoaderRoute: typeof PublicAppIdLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/submissions/$submissionId': {
      id: '/_authenticated/submissions/$submissionId'
      path: '/$submissionId'
      fullPath: '/submissions/$submissionId'
      preLoaderRoute: typeof AuthenticatedSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthenticatedSubmissionsRoute
    }
    '/_authenticated/staking/$validatorId': {
      id: '/_authenticated/staking/$validatorId'
      path: '/$validatorId'
      fullPath: '/staking/$validatorId'
      preLoaderRoute: typeof AuthenticatedStakingValidatorIdRouteImport
      parentRoute: typeof AuthenticatedStakingRoute
    }
    '/_authenticated/settings/team': {
      id: '/_authenticated/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/logs': {
      id: '/_authenticated/settings/logs'
      path: '/logs'
      fullPath: '/settings/logs'
      preLoaderRoute: typeof AuthenticatedSettingsLogsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/general': {
      id: '/_authenticated/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthenticatedSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/integrations/$integrationId': {
      id: '/_authenticated/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/integrations/$integrationId'
      preLoaderRoute: typeof AuthenticatedIntegrationsIntegrationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/management': {
      id: '/_authenticated/files/management'
      path: '/management'
      fullPath: '/files/management'
      preLoaderRoute: typeof AuthenticatedFilesManagementRouteImport
      parentRoute: typeof AuthenticatedFilesRoute
    }
    '/_authenticated/files/corrections': {
      id: '/_authenticated/files/corrections'
      path: '/corrections'
      fullPath: '/files/corrections'
      preLoaderRoute: typeof AuthenticatedFilesCorrectionsRouteImport
      parentRoute: typeof AuthenticatedFilesRoute
    }
    '/_authenticated/$appId/$': {
      id: '/_authenticated/$appId/$'
      path: '/$appId/$'
      fullPath: '/$appId/$'
      preLoaderRoute: typeof AuthenticatedAppIdSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(sources)/wallets/': {
      id: '/_authenticated/(sources)/wallets/'
      path: '/wallets'
      fullPath: '/wallets/'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(sources)/sources/': {
      id: '/_authenticated/(sources)/sources/'
      path: '/sources'
      fullPath: '/sources/'
      preLoaderRoute: typeof AuthenticatedsourcesSourcesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(sources)/exchanges/': {
      id: '/_authenticated/(sources)/exchanges/'
      path: '/exchanges'
      fullPath: '/exchanges/'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper': {
      id: '/_authenticated/client/$accountId/_clientWrapper'
      path: '/client/$accountId'
      fullPath: '/client/$accountId'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(sources)/sources/add': {
      id: '/_authenticated/(sources)/sources/add'
      path: '/sources/add'
      fullPath: '/sources/add'
      preLoaderRoute: typeof AuthenticatedsourcesSourcesAddRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/'
      path: '/'
      fullPath: '/client/$accountId/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/': {
      id: '/_authenticated/(sources)/wallets/$walletId/'
      path: '/wallets/$walletId'
      fullPath: '/wallets/$walletId/'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(sources)/exchanges/$exchangeId/': {
      id: '/_authenticated/(sources)/exchanges/$exchangeId/'
      path: '/exchanges/$exchangeId'
      fullPath: '/exchanges/$exchangeId/'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesExchangeIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/trial-expired': {
      id: '/_authenticated/client/$accountId/_clientWrapper/trial-expired'
      path: '/trial-expired'
      fullPath: '/client/$accountId/trial-expired'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperTrialExpiredRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/transactions': {
      id: '/_authenticated/client/$accountId/_clientWrapper/transactions'
      path: '/transactions'
      fullPath: '/client/$accountId/transactions'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperTransactionsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/submissions': {
      id: '/_authenticated/client/$accountId/_clientWrapper/submissions'
      path: '/submissions'
      fullPath: '/client/$accountId/submissions'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSubmissionsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/reports': {
      id: '/_authenticated/client/$accountId/_clientWrapper/reports'
      path: '/reports'
      fullPath: '/client/$accountId/reports'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperReportsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/planning': {
      id: '/_authenticated/client/$accountId/_clientWrapper/planning'
      path: '/planning'
      fullPath: '/client/$accountId/planning'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperPlanningRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/disabled': {
      id: '/_authenticated/client/$accountId/_clientWrapper/disabled'
      path: '/disabled'
      fullPath: '/client/$accountId/disabled'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperDisabledRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet'
      path: '/wallets/$walletId'
      fullPath: '/wallets/$walletId'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(sources)/exchanges/$exchangeId/_exchange': {
      id: '/_authenticated/(sources)/exchanges/$exchangeId/_exchange'
      path: '/exchanges/$exchangeId'
      fullPath: '/exchanges/$exchangeId'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/settings': {
      id: '/_authenticated/client/$accountId/_clientWrapper/settings'
      path: '/settings'
      fullPath: '/client/$accountId/settings'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/settings/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/settings/'
      path: '/'
      fullPath: '/client/$accountId/settings/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/integrations/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/integrations/'
      path: '/integrations'
      fullPath: '/client/$accountId/integrations/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/settings/team': {
      id: '/_authenticated/client/$accountId/_clientWrapper/settings/team'
      path: '/team'
      fullPath: '/client/$accountId/settings/team'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/settings/logs': {
      id: '/_authenticated/client/$accountId/_clientWrapper/settings/logs'
      path: '/logs'
      fullPath: '/client/$accountId/settings/logs'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsLogsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/settings/general': {
      id: '/_authenticated/client/$accountId/_clientWrapper/settings/general'
      path: '/general'
      fullPath: '/client/$accountId/settings/general'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/settings/billing': {
      id: '/_authenticated/client/$accountId/_clientWrapper/settings/billing'
      path: '/billing'
      fullPath: '/client/$accountId/settings/billing'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/integrations/$integrationId': {
      id: '/_authenticated/client/$accountId/_clientWrapper/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/client/$accountId/integrations/$integrationId'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet/summary': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet/summary'
      path: '/summary'
      fullPath: '/wallets/$walletId/summary'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletSummaryRouteImport
      parentRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet/settings': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet/settings'
      path: '/settings'
      fullPath: '/wallets/$walletId/settings'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletSettingsRouteImport
      parentRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet/reconciliation': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet/reconciliation'
      path: '/reconciliation'
      fullPath: '/wallets/$walletId/reconciliation'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletReconciliationRouteImport
      parentRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet/imports': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet/imports'
      path: '/imports'
      fullPath: '/wallets/$walletId/imports'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletImportsRouteImport
      parentRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet/defi': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet/defi'
      path: '/defi'
      fullPath: '/wallets/$walletId/defi'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletDefiRouteImport
      parentRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/(sources)/wallets/$walletId/_wallet/addresses': {
      id: '/_authenticated/(sources)/wallets/$walletId/_wallet/addresses'
      path: '/addresses'
      fullPath: '/wallets/$walletId/addresses'
      preLoaderRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletAddressesRouteImport
      parentRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/summary': {
      id: '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/summary'
      path: '/summary'
      fullPath: '/exchanges/$exchangeId/summary'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRouteImport
      parentRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/settings': {
      id: '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/settings'
      path: '/settings'
      fullPath: '/exchanges/$exchangeId/settings'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRouteImport
      parentRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/reconciliation': {
      id: '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/reconciliation'
      path: '/reconciliation'
      fullPath: '/exchanges/$exchangeId/reconciliation'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRouteImport
      parentRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/imports': {
      id: '/_authenticated/(sources)/exchanges/$exchangeId/_exchange/imports'
      path: '/imports'
      fullPath: '/exchanges/$exchangeId/imports'
      preLoaderRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeImportsRouteImport
      parentRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/'
      path: '/wallets'
      fullPath: '/client/$accountId/wallets/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/'
      path: '/sources'
      fullPath: '/client/$accountId/sources/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/'
      path: '/exchanges'
      fullPath: '/client/$accountId/exchanges/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/add': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/add'
      path: '/sources/add'
      fullPath: '/client/$accountId/sources/add'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/'
      path: '/wallets/$walletId'
      fullPath: '/client/$accountId/wallets/$walletId/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/'
      path: '/exchanges/$exchangeId'
      fullPath: '/client/$accountId/exchanges/$exchangeId/'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet'
      path: '/wallets/$walletId'
      fullPath: '/client/$accountId/wallets/$walletId'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange'
      path: '/exchanges/$exchangeId'
      fullPath: '/client/$accountId/exchanges/$exchangeId'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrapperRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/summary': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/summary'
      path: '/summary'
      fullPath: '/client/$accountId/wallets/$walletId/summary'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/settings': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/settings'
      path: '/settings'
      fullPath: '/client/$accountId/wallets/$walletId/settings'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/reconciliation': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/reconciliation'
      path: '/reconciliation'
      fullPath: '/client/$accountId/wallets/$walletId/reconciliation'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/imports': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/imports'
      path: '/imports'
      fullPath: '/client/$accountId/wallets/$walletId/imports'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/defi': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/defi'
      path: '/defi'
      fullPath: '/client/$accountId/wallets/$walletId/defi'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/addresses': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/addresses'
      path: '/addresses'
      fullPath: '/client/$accountId/wallets/$walletId/addresses'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/summary': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/summary'
      path: '/summary'
      fullPath: '/client/$accountId/exchanges/$exchangeId/summary'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/settings': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/settings'
      path: '/settings'
      fullPath: '/client/$accountId/exchanges/$exchangeId/settings'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/reconciliation': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/reconciliation'
      path: '/reconciliation'
      fullPath: '/client/$accountId/exchanges/$exchangeId/reconciliation'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute
    }
    '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/imports': {
      id: '/_authenticated/client/$accountId/_clientWrapper/(sources)/exchanges/$exchangeId/_exchange/imports'
      path: '/imports'
      fullPath: '/client/$accountId/exchanges/$exchangeId/imports'
      preLoaderRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRouteImport
      parentRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsGeneralRoute: typeof AuthenticatedSettingsGeneralRoute
  AuthenticatedSettingsLogsRoute: typeof AuthenticatedSettingsLogsRoute
  AuthenticatedSettingsTeamRoute: typeof AuthenticatedSettingsTeamRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
    AuthenticatedSettingsGeneralRoute: AuthenticatedSettingsGeneralRoute,
    AuthenticatedSettingsLogsRoute: AuthenticatedSettingsLogsRoute,
    AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedFilesRouteChildren {
  AuthenticatedFilesCorrectionsRoute: typeof AuthenticatedFilesCorrectionsRoute
  AuthenticatedFilesManagementRoute: typeof AuthenticatedFilesManagementRoute
  AuthenticatedFilesIndexRoute: typeof AuthenticatedFilesIndexRoute
}

const AuthenticatedFilesRouteChildren: AuthenticatedFilesRouteChildren = {
  AuthenticatedFilesCorrectionsRoute: AuthenticatedFilesCorrectionsRoute,
  AuthenticatedFilesManagementRoute: AuthenticatedFilesManagementRoute,
  AuthenticatedFilesIndexRoute: AuthenticatedFilesIndexRoute,
}

const AuthenticatedFilesRouteWithChildren =
  AuthenticatedFilesRoute._addFileChildren(AuthenticatedFilesRouteChildren)

interface AuthenticatedStakingRouteChildren {
  AuthenticatedStakingValidatorIdRoute: typeof AuthenticatedStakingValidatorIdRoute
  AuthenticatedStakingIndexRoute: typeof AuthenticatedStakingIndexRoute
}

const AuthenticatedStakingRouteChildren: AuthenticatedStakingRouteChildren = {
  AuthenticatedStakingValidatorIdRoute: AuthenticatedStakingValidatorIdRoute,
  AuthenticatedStakingIndexRoute: AuthenticatedStakingIndexRoute,
}

const AuthenticatedStakingRouteWithChildren =
  AuthenticatedStakingRoute._addFileChildren(AuthenticatedStakingRouteChildren)

interface AuthenticatedSubmissionsRouteChildren {
  AuthenticatedSubmissionsSubmissionIdRoute: typeof AuthenticatedSubmissionsSubmissionIdRoute
}

const AuthenticatedSubmissionsRouteChildren: AuthenticatedSubmissionsRouteChildren =
  {
    AuthenticatedSubmissionsSubmissionIdRoute:
      AuthenticatedSubmissionsSubmissionIdRoute,
  }

const AuthenticatedSubmissionsRouteWithChildren =
  AuthenticatedSubmissionsRoute._addFileChildren(
    AuthenticatedSubmissionsRouteChildren,
  )

interface AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteChildren {
  AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute
  AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute
  AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute
  AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute
  AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute
}

const AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteChildren: AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteChildren =
  {
    AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute:
      AuthenticatedClientAccountIdClientWrapperSettingsBillingRoute,
    AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute:
      AuthenticatedClientAccountIdClientWrapperSettingsGeneralRoute,
    AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute:
      AuthenticatedClientAccountIdClientWrapperSettingsLogsRoute,
    AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute:
      AuthenticatedClientAccountIdClientWrapperSettingsTeamRoute,
    AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute:
      AuthenticatedClientAccountIdClientWrapperSettingsIndexRoute,
  }

const AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteWithChildren =
  AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute._addFileChildren(
    AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteChildren,
  )

interface AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteChildren {
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute
}

const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteChildren: AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteChildren =
  {
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeImportsRoute,
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeReconciliationRoute,
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSettingsRoute,
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeSummaryRoute,
  }

const AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteWithChildren =
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute._addFileChildren(
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteChildren,
  )

interface AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteChildren {
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute
}

const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteChildren: AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteChildren =
  {
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletAddressesRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletDefiRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletImportsRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletReconciliationRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSettingsRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletSummaryRoute,
  }

const AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteWithChildren =
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute._addFileChildren(
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteChildren,
  )

interface AuthenticatedClientAccountIdClientWrapperRouteChildren {
  AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute: typeof AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteWithChildren
  AuthenticatedClientAccountIdClientWrapperDisabledRoute: typeof AuthenticatedClientAccountIdClientWrapperDisabledRoute
  AuthenticatedClientAccountIdClientWrapperPlanningRoute: typeof AuthenticatedClientAccountIdClientWrapperPlanningRoute
  AuthenticatedClientAccountIdClientWrapperReportsRoute: typeof AuthenticatedClientAccountIdClientWrapperReportsRoute
  AuthenticatedClientAccountIdClientWrapperSubmissionsRoute: typeof AuthenticatedClientAccountIdClientWrapperSubmissionsRoute
  AuthenticatedClientAccountIdClientWrapperTransactionsRoute: typeof AuthenticatedClientAccountIdClientWrapperTransactionsRoute
  AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute: typeof AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute
  AuthenticatedClientAccountIdClientWrapperIndexRoute: typeof AuthenticatedClientAccountIdClientWrapperIndexRoute
  AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute: typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute
  AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute: typeof AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute
  AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute
  AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute
  AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteWithChildren
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteWithChildren
  AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute
  AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute: typeof AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute
}

const AuthenticatedClientAccountIdClientWrapperRouteChildren: AuthenticatedClientAccountIdClientWrapperRouteChildren =
  {
    AuthenticatedClientAccountIdClientWrapperSettingsRouteRoute:
      AuthenticatedClientAccountIdClientWrapperSettingsRouteRouteWithChildren,
    AuthenticatedClientAccountIdClientWrapperDisabledRoute:
      AuthenticatedClientAccountIdClientWrapperDisabledRoute,
    AuthenticatedClientAccountIdClientWrapperPlanningRoute:
      AuthenticatedClientAccountIdClientWrapperPlanningRoute,
    AuthenticatedClientAccountIdClientWrapperReportsRoute:
      AuthenticatedClientAccountIdClientWrapperReportsRoute,
    AuthenticatedClientAccountIdClientWrapperSubmissionsRoute:
      AuthenticatedClientAccountIdClientWrapperSubmissionsRoute,
    AuthenticatedClientAccountIdClientWrapperTransactionsRoute:
      AuthenticatedClientAccountIdClientWrapperTransactionsRoute,
    AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute:
      AuthenticatedClientAccountIdClientWrapperTrialExpiredRoute,
    AuthenticatedClientAccountIdClientWrapperIndexRoute:
      AuthenticatedClientAccountIdClientWrapperIndexRoute,
    AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute:
      AuthenticatedClientAccountIdClientWrapperIntegrationsIntegrationIdRoute,
    AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute:
      AuthenticatedClientAccountIdClientWrapperIntegrationsIndexRoute,
    AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute:
      AuthenticatedClientAccountIdClientWrappersourcesSourcesAddRoute,
    AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesIndexRoute,
    AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute:
      AuthenticatedClientAccountIdClientWrappersourcesSourcesIndexRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsIndexRoute,
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdExchangeRouteWithChildren,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdWalletRouteWithChildren,
    AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute:
      AuthenticatedClientAccountIdClientWrappersourcesExchangesExchangeIdIndexRoute,
    AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute:
      AuthenticatedClientAccountIdClientWrappersourcesWalletsWalletIdIndexRoute,
  }

const AuthenticatedClientAccountIdClientWrapperRouteWithChildren =
  AuthenticatedClientAccountIdClientWrapperRoute._addFileChildren(
    AuthenticatedClientAccountIdClientWrapperRouteChildren,
  )

interface AuthenticatedsourcesExchangesExchangeIdExchangeRouteChildren {
  AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute
  AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute
  AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute
  AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute
}

const AuthenticatedsourcesExchangesExchangeIdExchangeRouteChildren: AuthenticatedsourcesExchangesExchangeIdExchangeRouteChildren =
  {
    AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute:
      AuthenticatedsourcesExchangesExchangeIdExchangeImportsRoute,
    AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute:
      AuthenticatedsourcesExchangesExchangeIdExchangeReconciliationRoute,
    AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute:
      AuthenticatedsourcesExchangesExchangeIdExchangeSettingsRoute,
    AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute:
      AuthenticatedsourcesExchangesExchangeIdExchangeSummaryRoute,
  }

const AuthenticatedsourcesExchangesExchangeIdExchangeRouteWithChildren =
  AuthenticatedsourcesExchangesExchangeIdExchangeRoute._addFileChildren(
    AuthenticatedsourcesExchangesExchangeIdExchangeRouteChildren,
  )

interface AuthenticatedsourcesWalletsWalletIdWalletRouteChildren {
  AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute
  AuthenticatedsourcesWalletsWalletIdWalletDefiRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletDefiRoute
  AuthenticatedsourcesWalletsWalletIdWalletImportsRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletImportsRoute
  AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute
  AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute
  AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute
}

const AuthenticatedsourcesWalletsWalletIdWalletRouteChildren: AuthenticatedsourcesWalletsWalletIdWalletRouteChildren =
  {
    AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute:
      AuthenticatedsourcesWalletsWalletIdWalletAddressesRoute,
    AuthenticatedsourcesWalletsWalletIdWalletDefiRoute:
      AuthenticatedsourcesWalletsWalletIdWalletDefiRoute,
    AuthenticatedsourcesWalletsWalletIdWalletImportsRoute:
      AuthenticatedsourcesWalletsWalletIdWalletImportsRoute,
    AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute:
      AuthenticatedsourcesWalletsWalletIdWalletReconciliationRoute,
    AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute:
      AuthenticatedsourcesWalletsWalletIdWalletSettingsRoute,
    AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute:
      AuthenticatedsourcesWalletsWalletIdWalletSummaryRoute,
  }

const AuthenticatedsourcesWalletsWalletIdWalletRouteWithChildren =
  AuthenticatedsourcesWalletsWalletIdWalletRoute._addFileChildren(
    AuthenticatedsourcesWalletsWalletIdWalletRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedAuthCallbackRoute: typeof AuthenticatedAuthCallbackRoute
  AuthenticatedClientsRoute: typeof AuthenticatedClientsRoute
  AuthenticatedContactsRoute: typeof AuthenticatedContactsRoute
  AuthenticatedDisabledRoute: typeof AuthenticatedDisabledRoute
  AuthenticatedEmailVerifiedRoute: typeof AuthenticatedEmailVerifiedRoute
  AuthenticatedFilesRoute: typeof AuthenticatedFilesRouteWithChildren
  AuthenticatedLogoutRoute: typeof AuthenticatedLogoutRoute
  AuthenticatedMonitoringRoute: typeof AuthenticatedMonitoringRoute
  AuthenticatedPlanningRoute: typeof AuthenticatedPlanningRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedStakingRoute: typeof AuthenticatedStakingRouteWithChildren
  AuthenticatedSubmissionsRoute: typeof AuthenticatedSubmissionsRouteWithChildren
  AuthenticatedTaxCheckoutRoute: typeof AuthenticatedTaxCheckoutRoute
  AuthenticatedTransactionsRoute: typeof AuthenticatedTransactionsRoute
  AuthenticatedTrialExpiredRoute: typeof AuthenticatedTrialExpiredRoute
  AuthenticatedUserSettingsRoute: typeof AuthenticatedUserSettingsRoute
  AuthenticatedVerifyEmailRoute: typeof AuthenticatedVerifyEmailRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAppIdSplatRoute: typeof AuthenticatedAppIdSplatRoute
  AuthenticatedIntegrationsIntegrationIdRoute: typeof AuthenticatedIntegrationsIntegrationIdRoute
  AuthenticatedClientIndexRoute: typeof AuthenticatedClientIndexRoute
  AuthenticatedIntegrationsIndexRoute: typeof AuthenticatedIntegrationsIndexRoute
  AuthenticatedsourcesSourcesAddRoute: typeof AuthenticatedsourcesSourcesAddRoute
  AuthenticatedClientAccountIdClientWrapperRoute: typeof AuthenticatedClientAccountIdClientWrapperRouteWithChildren
  AuthenticatedsourcesExchangesIndexRoute: typeof AuthenticatedsourcesExchangesIndexRoute
  AuthenticatedsourcesSourcesIndexRoute: typeof AuthenticatedsourcesSourcesIndexRoute
  AuthenticatedsourcesWalletsIndexRoute: typeof AuthenticatedsourcesWalletsIndexRoute
  AuthenticatedsourcesExchangesExchangeIdExchangeRoute: typeof AuthenticatedsourcesExchangesExchangeIdExchangeRouteWithChildren
  AuthenticatedsourcesWalletsWalletIdWalletRoute: typeof AuthenticatedsourcesWalletsWalletIdWalletRouteWithChildren
  AuthenticatedsourcesExchangesExchangeIdIndexRoute: typeof AuthenticatedsourcesExchangesExchangeIdIndexRoute
  AuthenticatedsourcesWalletsWalletIdIndexRoute: typeof AuthenticatedsourcesWalletsWalletIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedAuthCallbackRoute: AuthenticatedAuthCallbackRoute,
  AuthenticatedClientsRoute: AuthenticatedClientsRoute,
  AuthenticatedContactsRoute: AuthenticatedContactsRoute,
  AuthenticatedDisabledRoute: AuthenticatedDisabledRoute,
  AuthenticatedEmailVerifiedRoute: AuthenticatedEmailVerifiedRoute,
  AuthenticatedFilesRoute: AuthenticatedFilesRouteWithChildren,
  AuthenticatedLogoutRoute: AuthenticatedLogoutRoute,
  AuthenticatedMonitoringRoute: AuthenticatedMonitoringRoute,
  AuthenticatedPlanningRoute: AuthenticatedPlanningRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedStakingRoute: AuthenticatedStakingRouteWithChildren,
  AuthenticatedSubmissionsRoute: AuthenticatedSubmissionsRouteWithChildren,
  AuthenticatedTaxCheckoutRoute: AuthenticatedTaxCheckoutRoute,
  AuthenticatedTransactionsRoute: AuthenticatedTransactionsRoute,
  AuthenticatedTrialExpiredRoute: AuthenticatedTrialExpiredRoute,
  AuthenticatedUserSettingsRoute: AuthenticatedUserSettingsRoute,
  AuthenticatedVerifyEmailRoute: AuthenticatedVerifyEmailRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAppIdSplatRoute: AuthenticatedAppIdSplatRoute,
  AuthenticatedIntegrationsIntegrationIdRoute:
    AuthenticatedIntegrationsIntegrationIdRoute,
  AuthenticatedClientIndexRoute: AuthenticatedClientIndexRoute,
  AuthenticatedIntegrationsIndexRoute: AuthenticatedIntegrationsIndexRoute,
  AuthenticatedsourcesSourcesAddRoute: AuthenticatedsourcesSourcesAddRoute,
  AuthenticatedClientAccountIdClientWrapperRoute:
    AuthenticatedClientAccountIdClientWrapperRouteWithChildren,
  AuthenticatedsourcesExchangesIndexRoute:
    AuthenticatedsourcesExchangesIndexRoute,
  AuthenticatedsourcesSourcesIndexRoute: AuthenticatedsourcesSourcesIndexRoute,
  AuthenticatedsourcesWalletsIndexRoute: AuthenticatedsourcesWalletsIndexRoute,
  AuthenticatedsourcesExchangesExchangeIdExchangeRoute:
    AuthenticatedsourcesExchangesExchangeIdExchangeRouteWithChildren,
  AuthenticatedsourcesWalletsWalletIdWalletRoute:
    AuthenticatedsourcesWalletsWalletIdWalletRouteWithChildren,
  AuthenticatedsourcesExchangesExchangeIdIndexRoute:
    AuthenticatedsourcesExchangesExchangeIdIndexRoute,
  AuthenticatedsourcesWalletsWalletIdIndexRoute:
    AuthenticatedsourcesWalletsWalletIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicAuthErrorRoute: typeof PublicAuthErrorRoute
  PublicInvalidAuthRequestRoute: typeof PublicInvalidAuthRequestRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPwChangeRequiredRoute: typeof PublicPwChangeRequiredRoute
  PublicAppIdLoginRoute: typeof PublicAppIdLoginRoute
  PublicAppIdSignupRoute: typeof PublicAppIdSignupRoute
  PublicOauthCallbackProviderIdRoute: typeof PublicOauthCallbackProviderIdRoute
  PublicSignupTokenRoute: typeof PublicSignupTokenRoute
  PublicSignupIndexRoute: typeof PublicSignupIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAuthErrorRoute: PublicAuthErrorRoute,
  PublicInvalidAuthRequestRoute: PublicInvalidAuthRequestRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicPwChangeRequiredRoute: PublicPwChangeRequiredRoute,
  PublicAppIdLoginRoute: PublicAppIdLoginRoute,
  PublicAppIdSignupRoute: PublicAppIdSignupRoute,
  PublicOauthCallbackProviderIdRoute: PublicOauthCallbackProviderIdRoute,
  PublicSignupTokenRoute: PublicSignupTokenRoute,
  PublicSignupIndexRoute: PublicSignupIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
